interface ICycleTimeFormat {
  success: boolean
  data: number
  message: string | null
}

export const checkCycleTimeFormat = (
  cycleTime: string,
  type: string
): ICycleTimeFormat => {
  const data: ICycleTimeFormat = {
    success: false,
    data: 0,
    message: null
  }

  const cycleTimeString = String(cycleTime).trim()

  // Check if ':' exists
  if (!cycleTimeString.includes(':')) {
    data.message = `Missing ':' ${type} should be in mm:ss or hh:mm:ss format`
    return data
  }

  const arr = cycleTimeString.split(':')

  // Allow only mm:ss or hh:mm:ss
  if (arr.length !== 2 && arr.length !== 3) {
    data.message = `${type} should be in mm:ss or hh:mm:ss format`
    return data
  }

  // Check if all values are numeric
  if (arr.some((value) => value === '' || isNaN(Number(value)))) {
    data.message = `${type} contains invalid numbers`
    return data
  }

  let hours = 0
  let minutes = 0
  let seconds = 0

  if (arr.length === 2) {
    // mm:ss
    minutes = Number(arr[0])
    seconds = Number(arr[1])
  } else {
    // hh:mm:ss
    hours = Number(arr[0])
    minutes = Number(arr[1])
    seconds = Number(arr[2])
  }

  if (hours < 0 || minutes < 0 || seconds < 0) {
    data.message = `${type} cannot contain negative values`
    return data
  }

  if (minutes >= 60) {
    data.message = `Minutes should be less than 60 in ${type}`
    return data
  }

  if (seconds >= 60) {
    data.message = `Seconds should be less than 60 in ${type}`
    return data
  }

  return {
    success: true,
    data: hours * 3600 + minutes * 60 + seconds,
    message: null
  }
}
